// extracted by mini-css-extract-plugin
module.exports = {"product-card":"dualtext_product-card__f5WfO","dualtext__section":"dualtext_dualtext__section__T9WMo","container":"dualtext_container__rMIcp"};